module.exports = __webpack_public_path__ + "static/media/PORTFOLIO1.54e1619a.jpg";